/* eslint-disable */
'use strict';

import Helpers from "../shared/helpers";

const Buybox = {
    // Flag if the script is on the PDP
    pdp: window.location.pathname.includes('/products/'),

    /**
     * Init function
     */
    init: function() {
        this.bindEvents();
        this.handleOptionSelect();        
    },


    /**
     * Handle options select event
     * 
     */
    handleOptionSelect: function() {
        document.querySelectorAll('.js-product-option').forEach(el => {
            el.addEventListener('click', function(e) {
                let parentOptionElement = e.target.closest('.js-options-parent');

                const variantID = el.dataset.id;
                const supplyDays = el.dataset.supplyDays;
                const productID = el.dataset.productId;
                const variantData = Helpers.getVariantData(variantID);
                const parentListElements = document.querySelectorAll(`.quick-buy-modal__list[data-product-id="${productID}"]`);
                const activeVariant = parentOptionElement.querySelector('.js-product-option.active');
                const quantity = document.querySelector(`.js-quantity-${productID}`).value;

                if(Buybox.pdp) {
                    Helpers.updateBWP(variantData.sku, quantity);
                }

                // Handle active variant
                if(activeVariant){
                    activeVariant.classList.remove('active');
                }
                el.classList.add('active');

                parentListElements.forEach(parentListElement => {
                    parentListElement.dataset.product = variantID;
                });

                Buybox.setNewOptions(variantData, productID);
                custom(variantID, productID);
                
                if (Buybox.pdp && !parentOptionElement.classList.contains('quick-buy-modal__options-wrapper')) {
                    Buybox.setURLParams(variantID);
                }

                //handle purchase options change 
                // if(supplyDays) {
                //     Buybox.handlePurchaseOptionChange(supplyDays) 
                // }
            });
        });
    },

    handlePurchaseOptionChange: function(supplyDays) {
        let supplyDaysOptionSelect = document.querySelectorAll('.js-subscription-options');
        
        if (supplyDaysOptionSelect) {
            supplyDaysOptionSelect.forEach(selectElement => {
                let array = Array.from(selectElement.options)
                array.forEach(option => {
                    if (option.textContent && option.textContent.includes(supplyDays + '')) {                        
                        option.selected = true;
                        selectElement.dispatchEvent(new Event('change'));                        
                    }
                });
            });
        }
    },


    /**
    * Bind Events on new rendered elements
    */
    bindEvents: function() {
        document.querySelectorAll('.quick-buy-modal__list').forEach(el => {
            el.addEventListener('click', function(e) {
                const parentElement = el.closest('ul');
                const sellingPlanSelectElement = el.querySelector('select');

                if (e.target.nodeName !== 'SELECT' && e.target.nodeName !== 'OPTION') {
                    if (sellingPlanSelectElement) {
                        el.dataset.sellingPlan = sellingPlanSelectElement.value;
                    }
                    Buybox.setCartValues(el.dataset.product, el.dataset.sellingPlan, parentElement.nextElementSibling);
                }
            });
        });

        document.querySelectorAll('.js-subscription-options').forEach(el => {
            el.addEventListener('change', function(e) {

                const parentElement = el.closest('ul');
                const parentListElement = el.closest('li');
                const subscriptionChecked = parentListElement.querySelector('input').checked
                const variantData = Helpers.getVariantData(parentListElement.dataset.product);
                const selling_plan_id = el.value;
                const priceData = el.options[el.selectedIndex].dataset.price;
                const comparePriceData = el.options[el.selectedIndex].dataset.compareAtPrice;
                const supply_days = window.supplyDays.find(obj => obj.id === parseInt(parentListElement.dataset.product));

                parentListElement.dataset.sellingPlan = selling_plan_id;

                if (subscriptionChecked) {
                    Buybox.setCartValues(parentListElement.dataset.product, parentListElement.dataset.sellingPlan, parentElement.nextElementSibling);
                }
                
                if(supply_days && supply_days.supply_days) {
                    Buybox.setNewProductData(parentListElement, priceData, comparePriceData, supply_days.supply_days);
                } else {
                    Buybox.setNewProductData(parentListElement, priceData, comparePriceData)
                }

            });
        });
    },


    /**
     * Set new product data
     * @param {Object} selling_plan 
     * @param {Object} parentElement 
     */
    setNewProductData: function(parentElement, priceData, comparePriceData, supply_days) {
        const pricesSelector = parentElement.querySelector('.quick-buy-modal__list-price');
        const saveBadgeSelector = parentElement.querySelector('.js-save-extra');
        const pricePerDaySelector = parentElement.querySelector('.quick-buy-modal__list-price-text');

        const price = priceData;
        const compare_at_price = comparePriceData;

        // Update prices
        let comparePriceMarkup = ``;

        if (compare_at_price && compare_at_price > price) {
            comparePriceMarkup = `
            <span class="quick-buy-modal__list-price-sale">
                $${ (compare_at_price / 100).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) }
            </span>
            `;
        }

        const html = `              
            ${ comparePriceMarkup }
            $${ (price / 100).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) }
        `;

        pricesSelector.innerHTML = '';
        pricesSelector.insertAdjacentHTML('beforeend', html);

        // Update price per day
        if (pricePerDaySelector) {
            supply_days ? 
            pricePerDaySelector.innerHTML = `$${ (price / supply_days / 100).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) } per gel pack` :
            pricePerDaySelector.innerHTML = '';
        }


        // Update Save Badge
        if (compare_at_price && compare_at_price > price) {
            const priceDiff = (compare_at_price - price) * 100;
            let percent = priceDiff / compare_at_price;
            percent = Math.round(percent);
    
            saveBadgeSelector.innerHTML = `extra ${percent}%`;    
        }
        
    },


    /**
     * Render the new selling plans
     * 
     * @param {Object} data 
     * @param {Object} productID 
     */
    setNewOptions: function(data, productID) {
        //const parentElement = document.querySelector(`.quick-buy-modal__lists[data-id="${productID}"]`);
        var parentModal = document.querySelector(`.quick-buy-modal--${productID}`);
        // const optionsSelector = parentElement.querySelector('.js-subscription-options');
        // const pricesSelector = parentElement.querySelector('.quick-buy-modal__list-price');
        // const saveBadgeSelector = parentElement.querySelector('.js-save-extra');
        // const pricePerDaySelector = parentElement.querySelector('.quick-buy-modal__list-price-text');
        const supply_days = window.supplyDays.find(obj => obj.id === data.id);
        let supplyDays;
        
        // Empty options
        // if (optionsSelector) {
        //     optionsSelector.innerHTML = '';
        // }

        if (supply_days == undefined) {
            supplyDays = false;
        } else {
            supplyDays = supply_days.supply_days;
        }
       

        // Set new values for the Cart event
        Buybox.setCartValues(data.id, '', parentModal);

        // Insert all other selling plans dinamically
        // if (optionsSelector) {
        //     data.selling_plan_allocations.forEach((selling_plan_allocation, index) => {
        //         const customData = window.variantSellingPlans.find(e => e.selling_plan_id == selling_plan_allocation.selling_plan_id);
        //         let percent;
    
        //         // Get percentage of the discount
        //         if (selling_plan_allocation.compare_at_price && selling_plan_allocation.compare_at_price > selling_plan_allocation.price) {
        //             const priceDiff = (selling_plan_allocation.compare_at_price - selling_plan_allocation.price) * 100;
        //             percent = priceDiff / selling_plan_allocation.compare_at_price;
        //         }
    
        //         Buybox.setOptionMarkup({ 
        //             productID: data.id,
        //             selling_plan_id: selling_plan_allocation.selling_plan_id,
        //             selling_plan_name: customData.selling_plan_name,
        //             price: selling_plan_allocation.price,
        //             compare_at_price: selling_plan_allocation.compare_at_price,
        //             optionsSelector: optionsSelector,
        //             pricesSelector: pricesSelector,
        //             index: index,
        //             percent: percent,
        //             saveBadgeSelector: saveBadgeSelector,
        //             pricePerDaySelector: pricePerDaySelector,
        //             supply_days: supplyDays
        //         });
    
        //         // Set new values for the Cart event
        //         if (index === 0 && parentElement.querySelector('input').checked) {
        //             Buybox.setCartValues(data.id, selling_plan_allocation.selling_plan_id, parentElement.nextElementSibling);    
        //         }
    
        //         // Bind the new elements events
        //         Buybox.bindEvents();
        //     });
        // }

        // Update one time subscription with it's elements
        // Buybox.changeOneTimeData({
        //     price: data.price,
        //     compare_at_price: data.compare_at_price,
        //     pricesSelector: parentElement.querySelector('.js-otp-prices'),
        //     pricePerDaySelector: parentElement.querySelector('.js-price-per-day'),
        //     supply_days: supplyDays
        // });
    },


    /**
     * Change One Time option data
     * @param {Object} data 
     */
    changeOneTimeData: function(data) {
        let price;

        price = '$' + (data.price / 100).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2});

        if (data.pricePerDaySelector) {
            data.supply_days ?
            data.pricePerDaySelector.innerHTML = `$${ (data.price / data.supply_days / 100).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) } per gel pack` :
            data.pricePerDaySelector.innerHTML = '';
        }

        data.pricesSelector.innerHTML = '';
        data.pricesSelector.insertAdjacentHTML('beforeend', price);
    },


    /**
     * Prepare the markup for a selling plan option
     * 
     * @param {Object} data 
     * @returns 
     */
    setOptionMarkup: function(data) {
        let price;
        let option = `<option data-price="${data.price}" data-compare-at-price="${data.compare_at_price}" value="${ data.selling_plan_id }">${ data.selling_plan_name }</option>`;

        if (data.compare_at_price && data.compare_at_price > data.price) {
            price = `
            <span class="quick-buy-modal__list-price-sale">
                $${ (data.compare_at_price / 100).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) }
            </span>

            $${ (data.price / 100).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) }
            `;
        } else {
            price = '$' + (data.price / 100).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2});
        }

        if (data.index === 0) {
            data.pricesSelector.innerHTML = '';
            data.pricesSelector.insertAdjacentHTML('beforeend', price);


            if (data.pricePerDaySelector) {
                data.supply_days ?
                data.pricePerDaySelector.innerHTML = `$${ (data.price / data.supply_days / 100).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) } per gel pack` :
                data.pricePerDaySelector.innerHTML = '';
            }
             
            if(data.saveBadgeSelector) {
                data.saveBadgeSelector.innerHTML = `extra ${ Math.round(data.percent) }%`;
            }
        }
        
        data.optionsSelector.insertAdjacentHTML('beforeend', option);
    },


    /**
     * Set new values for Add to Cart event
     * 
     * @param {String} productID 
     * @param {String} sellingPlanID 
     * @param {Object} parentElement
     */
    setCartValues: function(productID, sellingPlanID, parentElement) {
        var formElement
        if(parentElement){
            formElement = parentElement.querySelector('form[action="/cart/add"]'); 
        }else{
            formElement = document.querySelector('form[action="/cart/add"]');
        }
        if(formElement){
            formElement.querySelector('.js-product-id').value = productID;
        }
        // parentElement.querySelector('.js-selling-plan').value = sellingPlanID;
    },


    setURLParams: function(variantID) {
         // URL Object Init
         let url = new URL(window.location.href)

         url.searchParams.set('variant', variantID)
         const newUrl = url.toString();
         window.history.pushState({ path: newUrl }, '', newUrl);
    }
};

export default Buybox;